"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Check = _interopRequireDefault(require("@quintoandar/cozy-icons/Check"));
var _js = _interopRequireDefault(require("@quintoandar/cozy-theme/tokens/js"));
var _getStepAvatarBackgroundColor = require("./getStepAvatarBackgroundColor");
var _StepAvatarBullet = _interopRequireDefault(require("./StepAvatarBullet"));
var _Avatar = _interopRequireDefault(require("../../Avatar"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var StepAvatar = function StepAvatar(_ref) {
  var active = _ref.active,
    completed = _ref.completed,
    icon = _ref.icon,
    isFirst = _ref.isFirst,
    isLast = _ref.isLast,
    isStatic = _ref.isStatic,
    light = _ref.light,
    noEndConnector = _ref.noEndConnector,
    noInitialConnector = _ref.noInitialConnector;
  var backgroundColor = (0, _getStepAvatarBackgroundColor.getStepAvatarBackgroundColor)({
    active: active,
    completed: completed
  });
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, isStatic && /*#__PURE__*/_react["default"].createElement(_StepAvatarBullet["default"], {
    light: light,
    isFirst: isFirst,
    isLast: isLast,
    noEndConnector: noEndConnector,
    noInitialConnector: noInitialConnector,
    "aria-hidden": true
  }), !isStatic && /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
    backgroundColor: backgroundColor,
    size: "extraSmall",
    textColor: active ? _js["default"].alias.color.icon.inverse["default"] : _js["default"].alias.color.icon.brand["default"],
    "aria-hidden": true
  }, completed ? /*#__PURE__*/_react["default"].createElement(_Check["default"], {
    htmlColor: _js["default"].alias.color.surface["default"],
    fontSize: "small"
  }) : icon));
};
StepAvatar.propTypes = process.env.NODE_ENV !== "production" ? {
  active: _propTypes["default"].bool,
  completed: _propTypes["default"].bool,
  icon: _propTypes["default"].number,
  isFirst: _propTypes["default"].bool,
  isLast: _propTypes["default"].bool,
  isStatic: _propTypes["default"].bool,
  light: _propTypes["default"].bool,
  noInitialConnector: _propTypes["default"].bool,
  noEndConnector: _propTypes["default"].bool
} : {};
var _default = exports["default"] = StepAvatar;